import {clamp, MiniSignal, padNum, performNextTick, random, texture} from "p3";
import definitions from "../../../definitions";
import GameScene from "../../../scenes/GameScene";
import Enemy from "./Enemy";

export default class EnemySimonSays extends Enemy {
    constructor() {
        super(definitions.ENEMY_ID.SIMON_SAYS);

        this.moveSpeed = 1000;
        this.linearDamping = 6;
        this.collisionDamping = 12;

        this.collisionRadius = 12;
        this.collisionOffsetX = -5;
        this.collisionOffsetY = -12;

        this.colour = 0x000000;
        this.colourTime = {current:0, max:0.6};

        this.allowDamagePushback = false;

        this.allowStrike = true;
        this.signals.struck = new MiniSignal();
    }

    init() {
        super.init();

        this.addViewWithTexture(PIXI.Texture.WHITE);
    }

    destroy() {

        super.destroy();
    }

    onViewAdded() {
        super.onViewAdded();

        this._tempGraphic = new PIXI.Sprite();
        this._view.tint = 0x000000;
        this._view.anchor.set(0.5, 1);
        this._view.width = 100;
        this._view.height = 170;
        this._view.anchor.set(0.5, 1);
    }


    takeDamage(amount) {
        if (!this.allowStrike)
            return;
        this.soundOut();
        this.signals.struck.dispatch(this);
        return false;
    }

    soundOut(){
        this._view.tint = this.colour;
        ////console.log('soundOut');
        this.colourTime.current = window.dt;
    }

    update() {
        super.update();

        if (this.colourTime.current > 0) {
            this.colourTime.current += window.dt;
            if (this.colourTime.current >= this.colourTime.max) {
                this._view.tint = 0x000000;
            }
        }
    }


    /**
     * @param {number} state
     * @private
     */
    
    onStateEnter(state) {
        switch (state) {

            case definitions.ENEMY_STATE.IDLE: {
                
                break;
            }
        }
    }

        /**
     * @param {number} state
     */
    onStateUpdate(state) {

        switch (state) {

            case definitions.ENEMY_STATE.IDLE: {
                
                break;
            }
        }
    }

}